export const Xs = 360
export const Sm = 480
export const Md = 769
export const Lg = 1024
export const Xl = 1280
export const Xxl = 1536

export const Screens = { Xs, Sm, Md, Lg, Xl, Xxl }
